import { render } from "./MfgPaintingProductionStatistics.vue?vue&type=template&id=4bf6e989&scoped=true"
import script from "./MfgPaintingProductionStatistics.vue?vue&type=script&lang=js"
export * from "./MfgPaintingProductionStatistics.vue?vue&type=script&lang=js"

import "./MfgPaintingProductionStatistics.vue?vue&type=style&index=0&id=4bf6e989&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf6e989"]])

export default __exports__